import React from 'react';
import Section from './layouts/Section';
import PageLayout from './layouts/PageLayout';

const StoreLocation = () => {
  return (
    <PageLayout
      title="Cell Station Store Location | 2500 W Moreland Rd, Willow Grove, PA"
      description="Visit Cell Station at 2500 W Moreland Rd, Space #1077, Willow Grove, PA 19090. Open 7 days a week for phone, tablet & computer repairs. Call (215) 939-3933."
      url="https://www.icellstation.com/store-location"
    >
      <Section title="Our locations">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-3 col-md-6 mt-40">
              <h4 className="font-w-600 text-white mb-10">Get in touch</h4>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-phone-alt mr-2" />
                <a href="tel:+12159393933" style={{ color: '#F50963' }}>
                  +1(215) 939-3933
                </a>
              </div>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-envelope mr-2" />
                <a href="mailto:icellstation1@gmail.com" style={{ color: '#F50963' }}>
                  icellstation1@gmail.com
                </a>
              </div>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-home mr-2" />
                2500 W Moreland Rd, Willow Grove, PA 19090 Space : #1077
              </div>
            </div>
          </div>
        </div>
            <iframe
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1112.526522562257!2d-75.12602792321633!3d40.13197566201095!2m3!1f0!2f39.121133786135466!3f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0x89c6b1fc42ab6fef%3A0x7c78b804e3a9c5ec!2sCell%20Station!5e1!3m2!1sen!2sus!4v1730661192650!5m2!1sen!2sus"
  width="100%"
  height="500"
  title="Cell Station Location"
  style={{ border: 0 }}
  allowFullScreen
/>
      </Section>
    </PageLayout>
  );
};

export default StoreLocation;
